import React, { useContext } from 'react';
import { ThemeContext } from '../hooks/ThemeContext';

const Legal = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';
  const h2 = `text-base font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`;
  const p = `text-sm leading-relaxed ${isDark ? 'text-gray-400' : 'text-gray-600'}`;

  return (
  <div
    className={`flex-1 ${isDark ? 'text-white' : 'text-gray-900'}`}
    style={{ backgroundColor: isDark ? '#07070a' : '#ffffff' }}
  >
    <div className="container mx-auto py-14 px-6 max-w-3xl flex flex-col gap-8">
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.25em] text-rose-400 block mb-3">Légal</span>
        <h1 className={`text-3xl font-black ${isDark ? 'text-white' : 'text-gray-900'}`} style={{ letterSpacing: '-0.02em' }}>
          Mentions légales &amp; CGV
        </h1>
      </div>

      <section className={`rounded-xl border p-6 flex flex-col gap-3 ${isDark ? 'border-white/[0.08] bg-white/[0.03]' : 'border-gray-200 bg-white'}`}>
        <h2 className={h2}>Éditeur du site</h2>
        <p className={p}>
          <strong>Krayne Agency</strong><br />
          Adresse : [Votre adresse]<br />
          Email : contact@krayne-agency.com<br />
          SIRET : [Votre numéro SIRET]<br />
          Directeur de la publication : [Votre nom]
        </p>
      </section>

      <section className={`rounded-xl border p-6 flex flex-col gap-3 ${isDark ? 'border-white/[0.08] bg-white/[0.03]' : 'border-gray-200 bg-white'}`}>
        <h2 className={h2}>Hébergement</h2>
        <p className={p}>
          Hébergeur : [Nom de l'hébergeur]<br />
          Adresse : [Adresse de l'hébergeur]<br />
          Téléphone : [Téléphone de l'hébergeur]
        </p>
      </section>

      <section className={`rounded-xl border p-6 flex flex-col gap-3 ${isDark ? 'border-white/[0.08] bg-white/[0.03]' : 'border-gray-200 bg-white'}`}>
        <h2 className={h2}>Propriété intellectuelle</h2>
        <p className={p}>
          L'ensemble du contenu du site (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive de Krayne Agency, sauf mention contraire. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable.
        </p>
      </section>

      <section className={`rounded-xl border p-6 flex flex-col gap-3 ${isDark ? 'border-white/[0.08] bg-white/[0.03]' : 'border-gray-200 bg-white'}`}>
        <h2 className={h2}>Données personnelles</h2>
        <p className={p}>
          Les informations recueillies sur ce site sont enregistrées dans un fichier informatisé par Krayne Agency pour la gestion de la clientèle. Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en contactant : contact@krayne-agency.com.
        </p>
      </section>

      <section className={`rounded-xl border p-6 flex flex-col gap-3 ${isDark ? 'border-white/[0.08] bg-white/[0.03]' : 'border-gray-200 bg-white'}`}>
        <h2 className={h2}>Conditions Générales de Vente (CGV)</h2>
        <p className={p}>
          Toute commande implique l'adhésion sans réserve du client aux présentes CGV. Les prestations proposées (création de site internet, hébergement, maintenance, etc.) font l'objet d'un devis personnalisé. Le paiement peut s'effectuer mensuellement ou en une fois selon l'accord convenu. Pour toute question, contactez-nous.
        </p>
      </section>

      <p className={`text-xs ${isDark ? 'text-gray-600' : 'text-gray-400'}`}>Dernière mise à jour : avril 2026</p>
    </div>
  </div>
  );
};

export default Legal;
